import LoginContainer from "../../containers/public";

const LoginPage = () => {
  return <LoginContainer />;
};

export default LoginPage;